import { types } from "./types";

export const signOutUser = () => ({
    type: types.SIGN_OUT,
  });

